<template>
    <v-autocomplete
        v-if="items && preferences && msd"
        auto-select-first
        autocomplete  = "off"
        autocorrect   = "off"
        autocapitalize= "off"
        spellcheck    = "false"
        :clearable    = "clearable"
        :label        = "label"
        :items        = "items"
        :rules        = "rules"
        :prepend-icon = "prependIcon"
        :hide-details = "hideDetails"
        item-value    = "id"
        item-text     = "name"
        v-model       = "selected"
        :readonly     = "readonly"
        :disabled     = "readonly"
        @change       = "onChange"
    />
</template>

<script>
export default {
    name: "CCustomerSelect",
    props: {
        value: {
            required: true
        },
        label: {
            required: false,
            default: function () {
                return null
            }
        },
        rules: {
            required: false,
            type    : Array
        },
        prependIcon: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },
        hideDetails: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
        additional: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },
        clearable: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },
        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
        myCustomers: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
        limCustomer: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    } ,

    data: () => ({
        selected: null
    }),

    watch: {
        value: {
            handler: function () {
                this.selected = this.value;
            },
            deep: true
        }
    },

    mounted() {
        this.selected = this.value
    },

    computed: {
        msd () {
            return this.$store.getters.msd;
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        items () {
            if (this.myCustomers) {
                return this.preferences.customer;
            }

            if (!this.preferences || !this.msd) {
                return [];
            }

            if (!this.preferences.customer) {
                return this.limCustomer ? this.msd.limCustomer : this.msd.customer;
            }

            let customer = this.preferences.customer.slice();
            if (customer.length === 0|| !this.myCustomers) {
                return this.limCustomer ? this.msd.limCustomer : this.msd.customer;
            }

            if (this.additional != null && !customer.find(c => c.id === this.additional.id)) {
                customer.push(this.additional);
            }

            return customer;
        }
    },

    methods: {
        onChange () {
            let customer = this.items.find (item => item.id === this.selected);
            this.$emit('input',customer);
            this.$emit('change',customer);
        },
    }
}
</script>

<style scoped>

</style>